// Shared clinical/demographic constants used in forms & filters

export const DEFAULT_HEALTH_STATUSES = [
  "Healthy",
  "Type I Diabetes",
  "Type II Diabetes",
  "Hypertension",
  "Asthma",
  "Fever",
  "AGE",
  "Tuberculosis",
  "Upper Respiratory Tract Infection",
  "UTI",
  "Hypothyroidism",
  "Hyperthyroidism",
  "Tonsilitis",
];

export const AGE_GROUPS = [
  "Newborn",
  "Infant",
  "Toddler",
  "Child",
  "Adolescent",
  "Young Adult",
  "Adult",
  "Elderly",
];

export const LEVELS_OF_PREVENTION = [
  "Primordial",
  "Primary",
  "Secondary",
  "Tertiary",
];

// Helper: derive an age group from a numeric age (used as default in forms)
export function ageGroupFromAge(age) {
  const a = parseInt(age, 10);
  if (isNaN(a) || a < 0) return "";
  if (a <= 0.08) return "Newborn"; // ~1 month
  if (a < 1) return "Infant";
  if (a < 3) return "Toddler";
  if (a < 13) return "Child";
  if (a < 18) return "Adolescent";
  if (a < 30) return "Young Adult";
  if (a < 60) return "Adult";
  return "Elderly";
}


// ---------- User profile dropdowns ----------
export const COURSES = [
  "B.Sc. Nursing",
  "M.Sc. Nursing",
  "GNM",
  "P.B.B.Sc. Nursing",
];

// Batch joining year — students are identified by the year they joined.
export const BATCHES = (() => {
  const list = [];
  for (let y = 2030; y >= 2015; y--) list.push(String(y));
  return list;
})();

export const DESIGNATIONS = [
  "Principal",
  "Vice Principal",
  "Professor",
  "Associate Professor",
  "Assistant Professor",
  "Lecturer",
  "Tutor",
  "Clinical Instructor",
];

// If a stored value isn't in the dropdown options (legacy data), include it so the user
// can still see/edit it without losing the value.
export function withCurrent(options, current) {
  if (!current || options.includes(current)) return options;
  return [current, ...options];
}
